module.exports = Cesium.ScreenSpaceEventType;